require("!!/Users/s.kressmann/Sites/PerformanceTrust/FutureShapeAngular/trunk/node_modules/script-loader/addScript.js")(require("!!/Users/s.kressmann/Sites/PerformanceTrust/FutureShapeAngular/trunk/node_modules/raw-loader/index.js!/Users/s.kressmann/Sites/PerformanceTrust/FutureShapeAngular/trunk/node_modules/hammerjs/hammer.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/hammerjs/hammer.min.js
// module id = 717
// module chunks = 7